<template>
  <div class="store-location-picker">
    <MapLocationPicker
      v-model:address="internalAddress"
      v-model:longitude="internalLongitude"
      v-model:latitude="internalLatitude"
      :amap-key="amapKey"
      :amap-secret="amapSecret"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import MapLocationPicker from './MapLocationPicker.vue'

const amapKey = import.meta.env.VITE_AMAP_KEY
const amapSecret = import.meta.env.VITE_AMAP_SECURITY_JS_CODE

const props = withDefaults(defineProps<{
  address?: string
  longitude?: number | string
  latitude?: number | string
}>(), {
  address: '',
  latitude: undefined,
  longitude: undefined,
})

const emit = defineEmits<{
  'update:address': [value: string]
  'update:longitude': [value?: number | undefined]
  'update:latitude': [value?: number | undefined]
}>()

const internalAddress = computed({
  get: () => props.address,
  set: (value) => emit('update:address', value),
})

const internalLongitude = computed({
  get: () => props.longitude,
  set: (value) => {
    const numValue = typeof value === 'string' ? parseFloat(value) : value
    emit('update:longitude', isNaN(numValue as number) ? undefined : numValue)
  },
})

const internalLatitude = computed({
  get: () => props.latitude,
  set: (value) => {
    const numValue = typeof value === 'string' ? parseFloat(value) : value
    emit('update:latitude', isNaN(numValue as number) ? undefined : numValue)
  },
})
</script>

<style scoped lang="scss">
.store-location-picker {
  width: 100%;
}
</style>